<template>
  <img :src="domain + src" :alt="alt" v-if="!isMask" />
  <div v-else :style="{ maskImage: `url(${domain + src})` }"></div>
</template>

<script>
export default {
  name: "ImageWrapper",
  props: {
    /**
     * Source path for the image (relative path)
     * @type {String}
     */
    src: {
      type: String,
      required: true,
    },
    isMask: {
      type: Boolean,
      default: false,
    },
    /**
     * Alt text for the image
     * @type {String}
     */
    alt: {
      type: String,
      default: "",
    },
  },
  computed: {
    /**
     * Gets the domain from the .env file configuration
     * @returns {String} The image domain URL
     */
    domain() {
      return "https://s3.ap-southeast-1.amazonaws.com/nespresso.web/2025double11";
      // return "";
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  // Add any specific styling for ImageWrapper if needed
}
</style>
